export const ATTACHMENT_PREFIX = 'attachment.';
